<template lang="pug">
table-base.student-list-table
  //- ヘッダー部
  table-row-base.student-list-table__row-header.text-medium
    table-header-base.student-list-table__row-header__cell
      .student-list-table__row-header__cell__checkbox(:data-selected='checkedAll')
        input.student-list-table__row-header__cell__checkbox__input(type='checkbox', v-model='isCheckedAll', :id='UID')
        label-base.student-list-table__row-header__cell__checkbox__label(:for='UID')
    table-header-base.student-list-table__row-header__cell.align-left
      toggle-sort.student-list-table__row-header__cell__toggle(
        :sortSetting='sort.userName',
        @change-sort='sortChangeEvent($event, "userName")'
      )
        slot(name='userNameHeader')
    table-header-base.student-list-table__row-header__cell.align-left
      toggle-sort.student-list-table__row-header__cell__toggle(
        :sortSetting='sort.bcbtCode',
        @change-sort='sortChangeEvent($event, "bcbtCode")'
      )
        slot(name='bcbtCodeHeader')
    table-header-base.student-list-table__row-header__cell.align-left(v-if='isAdmin')
      toggle-sort.student-list-table__row-header__cell__toggle(
        :sortSetting='sort.academyName',
        @change-sort='sortChangeEvent($event, "academyName")'
      )
        slot(name='academyNameHeader')
    table-header-base.student-list-table__row-header__cell.align-left(v-if='isAdminOrAcademy')
      toggle-sort.student-list-table__row-header__cell__toggle(
        :sortSetting='sort.branchName',
        @change-sort='sortChangeEvent($event, "branchName")'
      )
        slot(name='branchNameHeader')
    table-header-base.student-list-table__row-header__cell.align-left
      toggle-sort.student-list-table__row-header__cell__toggle(
        :sortSetting='sort.gradeName',
        @change-sort='sortChangeEvent($event, "gradeName")'
      )
        slot(name='gradeNameHeader')
    table-header-base.student-list-table__row-header__cell.align-left
      toggle-sort.student-list-table__row-header__cell__toggle(
        :sortSetting='sort.statusName',
        @change-sort='sortChangeEvent($event, "statusName")'
      )
        slot(name='statusNameHeader')
    table-header-base.student-list-table__row-header__cell.align-center
      slot(name='editHeader')
  template(v-for='studentData in studentDatas')
    //- 一覧表示部
    table-row-base.student-list-table__row.text-small.font-medium
      table-data-base.student-list-table__row__cell
        .student-list-table__row__cell__checkbox(:data-selected='dataSelected(studentData.id)')
          input.student-list-table__row__cell__checkbox__input(
            type='checkbox',
            :value='studentData.id',
            v-model='selectedValue',
            :id='getInputId(studentData.id)'
          )
          label-base.student-list-table__row__cell__checkbox__label(:for='getInputId(studentData.id)')
      table-data-base.student-list-table__row__cell
        .student-list-table__row__cell__text {{ studentData.userName }}
      table-data-base.student-list-table__row__cell
        .student-list-table__row__cell__text {{ studentData.bcbtCode }}
      table-data-base.student-list-table__row__cell(v-if='isAdmin')
        .student-list-table__row__cell__text {{ studentData.academyName }}
      table-data-base.student-list-table__row__cell(v-if='isAdminOrAcademy')
        .student-list-table__row__cell__text {{ studentData.branchName }}
      table-data-base.student-list-table__row__cell
        .student-list-table__row__cell__text {{ studentData.gradeName }}
      table-data-base.student-list-table__row__cell
        .student-list-table__row__cell__text {{ studentData.statusName }}
      table-data-base.student-list-table__row__cell
        popup-edit.student-list-table__row__cell__popup(
          :deleteEvent='deleteEvent',
          :editEvent='editEvent',
          :editId='studentData.id'
        )
          template(#removeText)
            slot(name='popupRemoveText')
          template(#editText)
            slot(name='popupEditText')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TableBase from '@/components/atoms/TableBase.vue'
import TableRowBase from '@/components/atoms/TableRowBase.vue'
import TableHeaderBase from '@/components/atoms/TableHeaderBase.vue'
import TableDataBase from '@/components/atoms/TableDataBase.vue'
import LabelBase from '@/components/atoms/LabelBase.vue'
import ToggleSort from '@/components/molecules/manager/ToggleSort.vue'
import PopupEdit from '@/components/organisms/manager/PopupEdit.vue'
import { StudentListType, StudentListSortType } from '@/models/studentListModel'
import { UserRoles } from '@/const/UserRoles'

/**
 * ユーザー管理（生徒）一覧テーブル
 */
@Component({
  components: {
    TableBase,
    TableRowBase,
    TableHeaderBase,
    TableDataBase,
    LabelBase,
    ToggleSort,
    PopupEdit,
  },
})
export default class StudentListTable extends Vue {
  // ユーザ権限
  @Prop()
  userRole!: UserRoles

  // 全チェックフラグ
  @Prop()
  checkedAll!: boolean

  // ヘッダーチェックボックスの変更イベント
  @Prop()
  headerCheckboxChangeEvent!: Function

  // ソート値（項目毎の昇順フラグ）
  @Prop()
  sort!: StudentListSortType

  // ソート値変更時イベント
  @Prop()
  sortChangeEvent!: Function

  // 生徒一覧情報
  @Prop()
  studentDatas!: StudentListType[]

  // 一覧内チェックボックスのチェックされた生徒ユーザID
  @Prop()
  checkedStudentUserIds!: number[]

  // 一覧内チェックボックスの変更イベント
  @Prop()
  checkboxChangeEvent!: Function

  // 削除イベント
  @Prop()
  deleteEvent!: Function

  // 編集イベント
  @Prop()
  editEvent!: Function

  // コンポーネント単位のユニークID取得
  private readonly UID = this.$uuid.v4()

  // inputタグの個別ID
  private getInputId(id: number): string {
    return `id${this.UID}_${id}`
  }

  // 選択状態に応じてカスタムデータ属性を付与
  private dataSelected(value: number): boolean {
    return this.checkedStudentUserIds.includes(value)
  }

  /**
   * ヘッダーチェックボックスのゲッターセッター
   */
  get isCheckedAll(): boolean {
    return this.checkedAll
  }
  set isCheckedAll(value: boolean) {
    // チェック時は一覧内の全チェックボックスをチェック、チェック解除時は全チェックボックスをチェック解除する
    const checkedIds = value
      ? this.studentDatas.map((studentData) => {
          return studentData.id
        })
      : []
    this.checkboxChangeEvent(checkedIds)
    this.headerCheckboxChangeEvent(value)
  }

  /**
   * チェックボックス選択値のゲッターセッター
   */
  get selectedValue(): number[] {
    return this.checkedStudentUserIds
  }
  set selectedValue(value: number[]) {
    // 全チェックボックスがチェックされていなければヘッダーのチェックボックスをチェック解除する
    if (value.length < this.studentDatas.length) {
      this.headerCheckboxChangeEvent(false)
    }
    this.checkboxChangeEvent(value)
  }

  // システム管理者であるか
  private get isAdmin(): boolean {
    return this.userRole === UserRoles.ADMIN
  }

  // システム管理者または塾管理者であるか
  private get isAdminOrAcademy(): boolean {
    return this.userRole === UserRoles.ADMIN || this.userRole === UserRoles.ACADEMY
  }
}
</script>

<style lang="stylus" scoped>
.student-list-table
  width 100%

  &__row-header,
  &__row
    border-bottom 1px solid var(--color-manager-list__border)

    &__cell
      &__checkbox
        display flex
        align-items center
        justify-content center

        &__input
          display none

        &__label
          width 20px
          height 20px
          background-image url("~@/assets/img/common/checkbox/off.svg")

        &[data-selected='true'] &__label
          background-image url("~@/assets/img/common/checkbox/on.svg")


  &__row-header
    background var(--color-manager-list__background)

    &__cell
      padding 10px 20px

      &:nth-child(1)
        width 65px
      &:nth-last-child(2)
        width 215px
      &:nth-last-child(1)
        width 130px

  &__row
    background var(--color-manager-list__background)
    height 55px

    &__cell
      padding 0 20px

      &__popup
        justify-content center

    &:hover
      background var(--color-manager-list__hover)
</style>
